Namespace 'Monitoring.Views.Dashboards.Modes.Explorer'

class Monitoring.Views.Dashboards.Modes.Explorer.SocialContentsAnalysisView extends Backbone.View

  template: JST["backbone/templates/monitoring/dashboards/modes/explorer/social_contents_analysis"]

  initialize: ({ searchQuery }) ->
    @searchQuery = searchQuery
    @vueSocialContentsAnalysisComponent = new VueInBackbone.VueApp('social-contents-analysis',
      {
        searchQuery: @searchQuery.toJSON(),
        show: false,
        theme: 'blue'
      }
    )
    @vueSocialContentsAnalysisComponent.on('hide', @hide)

  render: ->
    @$el.html(@template)
    @$el.find('.social-contents-analysis').append(@vueSocialContentsAnalysisComponent.el)
    @vueSocialContentsAnalysisComponent.render()
    @

  show: ->
    @vueSocialContentsAnalysisComponent.update({ show: true })

  hide: =>
    @vueSocialContentsAnalysisComponent.update({ show: false })

  update: (searchQuery) ->
    @searchQuery = searchQuery
    @vueSocialContentsAnalysisComponent.update({ searchQuery: searchQuery.toJSON() })

  destroy: ->
    @remove()

  remove: ->
    @vueSocialContentsAnalysisComponent.remove()
    super()
